import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry
    },

    state: {
        clickout: false
    },

    getters: {
        clickout: state => state.clickout
    },

    mutations: {
        setClickout: state =>
        {
            state.clickout = true;
        }
    },

    actions: {
        setClickout: ( context ) =>
        {
            context.commit( 'setClickout' );
        }
    }
});
